import { useMutation, useQuery, queryCache } from 'react-query';
import { ApplicationDispatch } from '../store/application/types';
import { fetchData, postData } from './fetch';
import { useDispatch } from 'react-redux';
import { IAppCustomerStipulation, IAppCustomerStipulationUpdateDTO, IStipulations } from '../Interfaces/StipulationTypes';
import { IAppCustomerStipulationCategoryStatus } from "../Interfaces/Common/IAppCustomerStipulationCategoryStatus";
import { Constants } from '../utils/constants';
import { hasValue } from "@amsanalytics/react-shared-library";
import { AppCustomerStipulationDocumentRequirement } from '../Interfaces/AppCustomerStipulationDocumentRequirement';
import { useSelector } from 'react-redux';
import { AppState } from '../store/rootReducer';

export const useApplicationCustomerStipulations = (applicationId: string) => {
  const dispatch = useDispatch<ApplicationDispatch>();
  const getApplicationCustomerStipulations = async (key: string, applicationId: string) => {
    if (hasValue(applicationId) && applicationId !== Constants.emptyGuid) {
      const url = `api/stipulations/list/${applicationId}`;
      const response = await fetchData(url, dispatch) as IStipulations;
      return response;
    }
    return undefined;
  }

  return useQuery(
    ['ApplicationCustomerStipulations', applicationId],
    getApplicationCustomerStipulations,
    {
      refetchOnWindowFocus: false,
    },
  );
}

// Gets list of outstanding stipulations for the application.
export const useOutstandingApplicationCustomerStipulations = (applicationId: string, isIndirect?: boolean) => {
  const dispatch = useDispatch<ApplicationDispatch>();
  const dealerServiceAppHistoryItems = useSelector((state: AppState) => state.applications.dealerServiceAppHistoryItems);
  const getOutstandingApplicationCustomerStipulations = async (key: string, applicationId: string) => {
    if (hasValue(applicationId) && applicationId !== Constants.emptyGuid) {
      const url = `api/stipulations/outstanding/${applicationId}`;
      const response = await fetchData(url, dispatch) as AppCustomerStipulationDocumentRequirement[];
      return response;
    }
    return undefined;
  }

  return useQuery(
    ['OutstandingApplicationCustomerStipulations', applicationId],
    getOutstandingApplicationCustomerStipulations,
    {
      refetchOnWindowFocus: false,
    },
  );
}

export const useUpdateApplicationStipulation = () => {
  const updateApplicationCustomerStipulation = async (updatedStipulation: IAppCustomerStipulationUpdateDTO) => {
    const url = `api/stipulations/updateAppCustomerStipulation`;
    const jsonResponse = await postData(url, updatedStipulation) as IAppCustomerStipulation;
    return jsonResponse;
  };

  return useMutation(updateApplicationCustomerStipulation, {
    onSuccess: async (data, updatedStipulation) => {
      await queryCache.refetchQueries(['ApplicationCustomerStipulations', updatedStipulation.applicationId]);
      await queryCache.refetchQueries(["appCustomerStipDocuments", updatedStipulation.applicationId]);
    }
  });
}

export const useUpdateAppCustomerStipulationCategoryStatus = (applicationId: string) => {
  const updateApplicationCustomerStipulation = async (updatedAppCustomerStipulationCategoryStatus: IAppCustomerStipulationCategoryStatus) => {
    const url = `api/stipulations/updateAppCustomerStipulationCategoryStatus`;
    const jsonResponse = await postData(url, updatedAppCustomerStipulationCategoryStatus) as IAppCustomerStipulationCategoryStatus;
    return jsonResponse;
  };

  return useMutation(updateApplicationCustomerStipulation, {
    onSuccess: async (data, updatedStipulation) => {
      await queryCache.refetchQueries(['ApplicationCustomerStipulations', applicationId]);
      await queryCache.refetchQueries(["appCustomerStipDocuments", applicationId]);
    }
  });
}